const base = 'SupportWidget';

const SupportWidgetKeys = {
  getConversations: `${base}/CONVERSATIONS`,
  getConversationSnapshot: `${base}/CONVERSATION_SNAPSHOT`,
  getConversationDetails: `${base}/CONVERSATION_DETAILS`,
  getTagsList: `${base}/TAGS_LIST`,
  getUserFeedback: `${base}/USER_FEEDBACK`,
};

export default SupportWidgetKeys;
